import LineIcon from '@/components/icons/LineIcon'
import { useLayoutContext } from '@/common/context/useLayoutContext'

const ThemeModeToggle = () => {
  const { theme, changeTheme } = useLayoutContext()
  const isDark = theme === 'dark'
  return (
    <div className="topbar-item">
      <button
        type="button"
        onClick={() => changeTheme(isDark ? 'light' : 'dark')}
        className="topbar-button pz-icon-btn"
        id="light-dark-mode"
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        aria-pressed={isDark}
      >
        {isDark ? <LineIcon name="sun" size={20} /> : <LineIcon name="moon" size={20} />}
      </button>
    </div>
  )
}

export default ThemeModeToggle
